import { isApiError } from '@botpress/client'
import { isAxiosError } from 'axios'

const HTTP_UNAUTHORIZED = 401

export function isHttpError(error: Error | unknown | undefined, httpCode: number) {
  return isAxiosError(error) && error.response?.status === httpCode
}

export function isHttpUnauthorizedError(error: Error | unknown | undefined) {
  if (isApiError(error)) {
    return error.type === 'Unauthorized' || isHttpError(error.error, HTTP_UNAUTHORIZED)
  }
  return isHttpError(error, HTTP_UNAUTHORIZED)
}

export function isForbiddenError(error: Error | unknown | undefined) {
  if (isApiError(error)) {
    return error.type === 'Forbidden' || isHttpError(error.error, 403)
  }
  return isHttpError(error, 403)
}

export function isBreakingChangeError(error: Error | unknown | undefined) {
  return isApiError(error) && error.type === 'BreakingChanges'
}
